import type { TemporalLocale } from "@/locales/fr/temporal";

const temporalLocale: TemporalLocale = {
  temporal: {
    nLastDays: "Today | {n} last days",
    nLastMonths: "This month | {n} last months",
    fromTo: "From {from} to {to}",
    datetime: "{date} at {time}",
  },
};

export default temporalLocale;
